import { AddressModel } from '../AddressEditor/types';

export type BookingType = 'Flexible' | 'Bundled';

export class StartFlexibleBookingRequestModel {
	Type: BookingType = 'Flexible';
	PackageId: number = 0;
	GameIds: number[] = [];
	Games: StartBookingGameRequestModel[] = [];
	PackageExperienceInventoryIds: number[] = [];
	PackageExperiences: StartBookingExperienceRequestModel[] = [];
	PackageTravelExperienceInventoryIds: number[] = [];
	PackageTravelExperiences: StartBookingTravelExperienceRequestModel[] = [];

	constructor(data: Partial<StartFlexibleBookingRequestModel> = {}) {
		Object.assign(this, data);
	}
}

export class StartBookingGameRequestModel {
	GameId: number = null!;
	HospitalityTicketInventoryId?: number;
	NumberOfPeople: number = null!;
	AccommodationInventoryId?: number;
	NumberOfRooms?: number;
	ExperienceInventoryIds: number[] = [];
	Experiences: StartBookingExperienceRequestModel[] = [];
	TravelExperienceInventoryIds: number[] = [];
	TravelExperiences: StartBookingTravelExperienceRequestModel[] = [];

	constructor(data: Partial<StartBookingGameRequestModel> = {}) {
		Object.assign(this, data);
	}
}

export class StartBookingExperienceRequestModel {
	ExperienceInventoryId: number = null!;
	NumberOfPeople: number = null!;

	constructor(data: Partial<StartBookingExperienceRequestModel> = {}) {
		Object.assign(this, data);
	}
}

export class StartBookingTravelExperienceRequestModel {
	TravelExperienceInventoryId: number = null!;
	NumberOfPeople: number = null!;
	NumberOfRooms: number = null!;

	constructor(data: Partial<StartBookingTravelExperienceRequestModel> = {}) {
		Object.assign(this, data);
	}
}

export class ConfirmBookingRequestModel {
	FirstName: string = '';
	LastName: string = '';
	Email: string = '';
	Phone: string = '';
	IsCorporateGroup: boolean = false;
	CompanyName?: string;
	PurchaseOrderNumberOrReference?: string;
	CompanyAddress?: AddressModel;
	AgreeToPromotions: boolean = false;
	AgreeToSTHPromotions: boolean = false;
	AgreeToShareDetails: boolean = false;
	AgreeToTermsAndConditions: boolean = false;

	constructor(data: Partial<ConfirmBookingRequestModel> = {}) {
		Object.assign(this, data);
	}
}

export type PaymentType = 'BankTransfer' | 'CreditCard' | 'CreditCardPxFusion';

export class BookingPaymentRequestModel {
	BookingId: string = '';
	PaymentType?: PaymentType;

	constructor(data: Partial<BookingPaymentRequestModel> = {}) {
		Object.assign(this, data);
	}
}

export interface RedirectUrlModel {
	RedirectUrl: string;
}

export class StartBundledBookingRequestModel {
	Type: BookingType = 'Bundled';
	PackageId: number = 0;
	NumberOfPeople: number = null!;
	NumberOfRooms: number = null!;

	constructor(data: Partial<StartBundledBookingRequestModel> = {}) {
		Object.assign(this, data);
	}
}
